import React from 'react';
import WordList from 'components/triggers/WordList';
import {List} from 'immutable';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import {CogIcon} from '@components/icon/CogIcon';

export default class WordListContext extends React.Component {
  constructor(props) {
    super(props);

    this.feedbackContainsChange = this.feedbackContainsChange.bind(this);
    this.feedbackContainsRemove = this.feedbackContainsRemove.bind(this);
    this.feedbackContainsInitialize = this.feedbackContainsInitialize.bind(this);
  }

  feedbackContainsInitialize() {
    const {context} = this.props;

    if (!context || context.matching.size === 0) {
      this.feedbackContainsChange(-1, '');
    }
  }

  feedbackContainsChange(index, value) {
    const {context} = this.props;
    const matching = context.matching || List();
    const newMatching = index >= 0 ? matching.set(index, value) : matching.push(value);
    this.props.contextChange(context.set('matching', newMatching));
  }

  feedbackContainsRemove(index) {
    const {context} = this.props;
    this.props.contextChange(context.deleteIn(['matching', index]));
  }

  render() {
    const {context, label} = this.props;
    const words = (context && context.matching) || List();

    if (words.size === 0) {
      return (
        <TriggerIconButton
          icon={<CogIcon tooltip="Edit" />}
          label={label + ' contains specific words'}
          onClick={() => this.feedbackContainsChange(-1, '')}
        />
      );
    }

    return (
      <div className="feedback-rule-type-select feedback-option">
        <div className="rule-context">
          <div className="feedback-contains">{`${label}`}</div>
          <WordList
            words={words}
            onWordChange={this.feedbackContainsChange}
            removeWord={this.feedbackContainsRemove}
          />
        </div>
      </div>
    );
  }
}
